import { Tooltip, TooltipProps, tooltipClasses } from '@mui/material';
import React, { ReactElement } from 'react';
//import styled from 'styled-components';
import { styled } from '@mui/material/styles';
import InfoIcon from "@mui/icons-material/Info";
import {  useMediaQuery, useTheme } from '@mui/material';

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip
        {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#DCDCDC',
        color: '#212121',
        maxWidth:290,
        padding:'16px 16px 16px 16px'
    },
    [`& .${tooltipClasses.arrow}`]:{
        color: '#DCDCDC',
    },
}));

interface CustomToolTipProps extends Pick<TooltipProps, "className"> {
    title: string;

}

const CustomToolTipComponent: React.FC<CustomToolTipProps> = ({ title, className, ...props }) => {
    const { breakpoints } = useTheme();

    const isDesktop = useMediaQuery(breakpoints.up('lg'));
    const isTablet = useMediaQuery(breakpoints.down('md'));
    const isMobile = useMediaQuery(breakpoints.down('sm'));
    return (


        <CustomTooltip {...props} title={title} arrow placement={ isMobile ? "bottom-start" : "left"}>
            <div style={{width: 16, height: 16, display: 'flex', justifyContent: 'flex-end', alignItems: 'center',paddingLeft:'12px'}}>
                < InfoIcon
                    style={{
                        color: '#8F8F8F',
                        cursor: 'pointer',
                        width: 16,
                        height: 16,
                        display: 'flex',
                        justifyContent: 'flex-end',
                        textAlign:'right',
                        marginLeft:'8px',
                    }}
                />
            </div>
        </CustomTooltip>
    )
}

export default CustomToolTipComponent;